<template>
    <div class="flex justify-center mx-2 relative">
<!--        <Select v-model="selectedCountry" :options="countries" optionLabel="name" placeholder="Select a Country"-->
<!--            class="w-full md:w-56"-->
<!--        >-->
<!--            <template #value="slotProps">-->
<!--                <div v-if="slotProps.value" class="flex items-center">-->
<!--                    <i :class="`fi fi-${slotProps.value.icon.toLowerCase()}`"></i>-->
<!--                    <div>{{ t(slotProps.value.name) }}</div>-->
<!--                </div>-->
<!--                <span v-else>-->
<!--                    {{ slotProps.placeholder }}-->
<!--                </span>-->
<!--            </template>-->
<!--            <template #option="slotProps">-->
<!--                <div class="flex items-center">-->
<!--                    <i :class="`fi fi-${slotProps.option.icon.toLowerCase()}`"></i>-->
<!--                    <div>{{ t(slotProps.option.name) }}</div>-->
<!--                </div>-->
<!--            </template>-->
<!--            <template #dropdownicon>-->
<!--                <i class="pi pi-language" />-->
<!--            </template>-->
<!--        </Select>-->
      <Button
          icon="pi pi-language"
          iconPos="right"
          :label="code"
          @click="toggle"
          class="mx-2 w-auto h-auto bg-transparent hover:bg-transparent focus:bg-transparent border-0 bg-red-600 text-red-700 rounded hover:bg-red-600 hover:text-white focus:outline-none focus:bg-red-600" />
      <Popover ref="op">
        <div class="flex flex-col gap-4">
          <div>
            <ul class="list-none p-0 m-0 flex flex-col">
              <li v-for="lang in countries" :key="lang.name" class="flex items-center gap-2 px-2 py-3 hover:bg-red-600/10 cursor-pointer rounded-border" @click="selectMember(lang)">
                <div class="flex items-center">
                  <i :class="`fi fi-${lang.icon.toLowerCase()}`"></i>
                  <div>{{ t(lang.name) }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </Popover>
    </div>
</template>
<script setup>
import { ref } from "vue";

import Popover from 'primevue/popover';

const op = ref();

import { useLocaleStore } from '~/stores/locale/index.js';
const localeStore = useLocaleStore();

const { locale, t } = useI18n()
const selectedCountry = ref();
console.log(locale.value, localeStore.language)
selectedCountry.value= localeStore.language === 'en'?{ name: 'english', icon: 'gb', code: 'en' }:{ name: 'french', icon: 'fr', code: 'fr' }
// selectedCountry.value= localeStore.language === 'en'?{ name: 'english', icon: 'gb', code: 'en' }:(
//     localeStore.language === 'fr'? { name: 'french', icon: 'fr', code: 'fr' }:{ name: 'german', icon: 'de', code: 'de' }
// )

const code = computed(()=>selectedCountry?.value?.code.toUpperCase())

const countries = ref([
    { name: 'french', icon: 'fr', code: 'fr' },
    { name: 'english', icon: 'gb', code: 'en' },
    // { name: 'german', icon: 'de', code: 'de' }
]);
const toggle = (event) => {
  op.value.toggle(event);
}

const selectMember = (lang) => {
  console.log(lang)
  selectedCountry.value = lang;
  localeStore.setLanguage(lang.code);
  // op.value.hide();
}

// Initialiser la langue d'i18n avec celle du store
locale.value = localeStore.language;

// Watcher pour détecter le changement de pays sélectionné
watch(selectedCountry, (newValue) => {
    if (newValue && newValue.code) {
      localeStore.setLanguage(newValue.code);
    }
});
</script>

<style scoped>
.bg-red-600 {     --tw-bg-opacity: 1;     background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1))!important; }

.text-red-700 {     --tw-text-opacity: 1;     color: rgb(185 28 28 / var(--tw-text-opacity, 1))!important; }

.fi {
    margin-right: 5px;
}

.p-popover {
  z-index: 9999 !important;
}

.p-button {
  background: transparent !important;
  border: none !important;
}

.p-select {
    width: 150px;
    height: 30px;
}

.p-placeholder {
    padding: 6px 10px;
    font-size: 11px;
}

.p-select-label {
    padding: 6px 10px;
    font-size: 11px;
}

.p-select-option {
    font-size: 11px;
}
</style>
